import CreateListResourceInteractor from "../../core/interactor/app/crud/CreateListResourceInteractor";
import { IIndexTypeAttribute } from "../model/IndexTypeAttribute";

export default class CreateIndexTypeAttributesInteractor {
  private createListResource: CreateListResourceInteractor<IIndexTypeAttribute>;

  constructor({ createListResource }: any) {
    this.createListResource = createListResource;
  }

  async execute(indexTypeAttributes: IIndexTypeAttribute[]) {
    return this.createListResource.execute(
      `/index-type-attribute`,
      indexTypeAttributes
    );
  }
}
